module.exports = __webpack_public_path__ + "static/media/surprise-reading.c6a4c6e4.jpg";